<template>
  <div>
    <div class="form-group">
      <label>Customer Type</label><br>
      <label class="radio-inline">
        <input v-model="customerType"
               type="radio"
               name="customer_type"
               id="customer_type_personal"
               value="personal"
               :tabindex="isTabbable"
               required
        > Personal
      </label>
      <label class="radio-inline">
        <input v-model="customerType"
               type="radio"
               name="customer_type"
               id="customer_type_business"
               value="business"
               :tabindex="isTabbable"
               required
        > Business
      </label>
    </div>
    <div class="form-group material row" v-show="customerType === 'personal'">
      <div class="col-sm-6">
        <div style="position:relative;">
          <input v-model="first_name"
                 type="text"
                 :class="inputClass(first_name)"
                 id="legal_info[first_name]"
                 name="legal_info[first_name]"
                 :required="customerType === 'personal'"
                 :tabindex="isTabbable"
                 :autocomplete="first_name ? 'nope': 'on'"
          >
          <span class="highlight"></span>
          <span class="bar"></span>
          <label for="legal_info[first_name]">First Name</label>
        </div>
      </div>
      <div class="col-sm-6">
        <div style="position:relative;">
          <input v-model="last_name"
                 type="text"
                 :class="inputClass(last_name)"
                 id="legal_info[last_name]"
                 name="legal_info[last_name]"
                 :required="customerType === 'personal'"
                 :tabindex="isTabbable"
                 :autocomplete="last_name ? 'nope': 'on'"
          >
          <span class="highlight"></span>
          <span class="bar"></span>
          <label for="legal_info[last_name]">Last Name</label>
        </div>
      </div>
    </div>
    <div class="form-group material" v-show="customerType === 'business'">
      <input v-model="business_name"
             type="text"
             :class="inputClass(business_name)"
             id="legal_info[business_name]"
             name="legal_info[business_name]"
             :required="customerType === 'business'"
             :tabindex="isTabbable"
             :autocomplete="business_name ? 'nope': 'on'"
      >
      <span class="highlight"></span>
      <span class="bar"></span>
      <label for="legal_info[business_name]">Business Name</label>
    </div>
    <div class="form-group material">
      <input v-model="email"
             type="email"
             :class="inputClass(email)"
             id="legal_info[email]"
             name="legal_info[email]"
             required
             :tabindex="isTabbable"
             :autocomplete="email ? 'nope': 'on'"
      >
      <span class="highlight"></span>
      <span class="bar"></span>
      <label for="legal_info[email]">Email</label>
    </div>
    <div class="form-group material">
      <input v-model="street1"
             type="text"
             :class="inputClass(street1)"
             id="legal_info[street1]"
             name="legal_info[street1]"
             required
             ref="legal"
             placeholder=""
             :autocomplete="street1 ? 'nope': 'on'"
             :tabindex="isTabbable"
      >
      <span class="highlight"></span>
      <span class="bar"></span>
      <label for="legal_info[street1]">Address</label>
    </div>
    <div class="form-group material">
      <input v-model="city"
             type="text"
             :class="inputClass(city)"
             id="legal_info[city]"
             name="legal_info[city]"
             required
             :autocomplete="city ? 'nope': 'on'"
             :tabindex="isTabbable"
      >
      <span class="highlight"></span>
      <span class="bar"></span>
      <label for="legal_info[city]">City</label>
    </div>
    <div class="form-group material">
      <select v-model="province"
              :class="inputClass(province)"
              id="legal_info[province]"
              name="legal_info[province]"
              required
              :autocomplete="province ? 'nope': 'on'"
              :tabindex="isTabbable"
      >
        <option value=""></option>
        <option value="MB">Manitoba</option>
        <optgroup label="----">
          <option value="AB">Alberta</option>
          <option value="BC">British Columbia</option>
          <option value="NB">New Brunswick</option>
          <option value="NL">Newfoundland and Labrador</option>
          <option value="NS">Nova Scotia</option>
          <option value="NT">Northwest Territories</option>
          <option value="NU">Nunavut</option>
          <option value="ON">Ontario</option>
          <option value="PE">Prince Edward Island</option>
          <option value="QC">Quebec</option>
          <option value="SK">Saskatchewan</option>
          <option value="YT">Yukon</option>
        </optgroup>
      </select>
      <span class="highlight"></span>
      <span class="bar"></span>
      <label for="legal_info[province]">Province</label>
    </div>
    <div class="form-group material">
      <input v-model="postal_code"
             type="text"
             :class="inputClass(postal_code)"
             id="legal_info[postal_code]"
             name="legal_info[postal_code]"
             required
             :autocomplete="postal_code ? 'nope': 'on'"
             :tabindex="isTabbable"
      >
      <span class="highlight"></span>
      <span class="bar"></span>
      <label for="legal_info[postal_code]">Postal Code</label>
    </div>

    <div class="form-group material" v-if="customerType === 'business' && showGst">
      <input type="text"
             class="form-control"
             id="gst_sbrn"
             name="legal_info[gst_sbrn]"
             :required="customerType === 'business'"
             :tabindex="isTabbable"
      >
      <span class="highlight"></span>
      <span class="bar"></span>
      <label for="legal_info[gst_sbrn]">GST/SBRN #</label>
    </div>

    <input type="hidden" name="legal_info[country]" value="CA" autocomplete="off">
  </div>
</template>

<script>
import {MdAutocomplete} from 'vue-material/dist/components'
import {useUserStore} from "../stores/user";
import {storeToRefs} from "pinia";

export default {
  setup() {
    const userStore = useUserStore()
    userStore.fetchMe();
    const ref = storeToRefs(userStore)

    return {
      name: ref.name,
      first_name: ref.first_name,
      last_name: ref.last_name,
      business_name: ref.business_name,
      email: ref.email,
      street1: ref.street1,
      city: ref.city,
      province: ref.province,
      postal_code: ref.postal_code,
      gst_sbrn: ref.gst_sbrn,
      paymentMethod: ref.paymentMethod,
      customerType: ref.customerType,
      isLoggedIn: ref.isLoggedIn,
    }
  },
  components: {
    MdAutocomplete,
  },
  props: {
    isLoggedIn: Boolean,
    isTabbable: Number,
    old: Object|null,
    showGst: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({}),
  mounted: function () {
    if (this.old) {
      this.first_name = this.old.first_name
      this.last_name = this.old.last_name
      this.business_name = this.old.business_name
      this.email = this.old.email
      this.street1 = this.old.street1
      this.city = this.old.city
      this.province = this.old.province
      this.postal_code = this.old.postal_code
      this.gst_sbrn = this.old.gst_sbrn
      this.country = this.old.country
    }

    const legalAutocomplete = new google.maps.places.Autocomplete(this.$refs["legal"]);
    legalAutocomplete.setComponentRestrictions({country: ["ca"]});
    legalAutocomplete.addListener("place_changed", () => {
      const place = legalAutocomplete.getPlace();
      place.address_components.forEach((component) => {
        const addressType = component.types[0];
        switch (addressType) {
          case "street_number":
            this.street1 = component.long_name;
            break;
          case "route":
            this.street1 += " " + component.short_name;
            break;
          case "locality":
            this.city = component.long_name;
            break;
          case "administrative_area_level_1":
            this.province = component.short_name;
            break;
          case "postal_code":
            this.postal_code = component.long_name;
            break;
            // case "country":
            //   this.shipTo.country = component.short_name;
            //   break;
        }
      });
    })
  },
  methods: {
    inputClass: function (val, classes = '') {
      return val ? 'form-control used ' + classes : 'form-control ' + classes;
    }
  },
  computed: {},
  watch: {}
}
</script>
